<template>
  <div>
    Authentication complete. You can return to the application. Feel free to close this browser tab.
  </div>
</template>
<script>
import Cookies from "js-cookie";
import store from '../store';

// marker ให้หน้า login ฝั่ง opener กรอง message ของคนอื่นทิ้งได้ ต้องตรงกับค่าใน Login.vue
const CONST_SSO_MESSAGE_TYPE = 'fusion-sso-login';

export default {
  name: 'RedirectFromLogin',
  data() {
    return {
      parameterURL: [],
    };
  },
  watch: {
  },
  mounted: async function () {
    for (let key in this.$route.query) {
      this.parameterURL[key.toLowerCase()] = this.$route.query[key];
    }
    if(this.parameterURL.user == 'true')
    {
      await this.GetUserProfile();
    }
    else if(this.parameterURL.userchat == 'true')
    {
      await this.GetUserChatProfile();
    }
  },
  methods: {
    async GetUserProfile() {
      this.$call.GetUserProfile(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data != null)
            {
              const User = dataResponse.data;
              Cookies.set('userId', User.userId);
              Cookies.set('username', User.username);
              Cookies.set('fullName', User.fullName);
              Cookies.set('roleId', User.roleId);
              Cookies.set('authenticated', true);
              store.state.status = 'success';
              store.state.token = User.token;
              store.state.userid = User.userId;
              store.state.username = User.username;
              store.state.fullName = User.fullName;
              store.state.roleId = User.roleId;
              store.state.isLoggedIn = true;
              localStorage.setItem('flag', 'us');
              localStorage.setItem('locale', 'en');
              store.state.languages = 'en';

              // เดิมผูก postMessage ไว้กับ window.onbeforeunload แล้วเรียก window.close() ทันที
              // browser ไม่การันตีว่าจะรัน handler ให้เมื่อปิดหน้าต่างด้วยสคริปต์
              // หน้าหลักเลยไม่ได้ message ไม่ reload ผู้ใช้ต้องกด F5 เอง
              // ยิงตรง ๆ ก่อนปิดแบบเดียวกับ GetUserChatProfile
              this.notifyOpenerAndClose({
                cookies: document.cookie,
                sessionUserId: User.userId,
                sessionUsername: User.username,
                sessionFullName: User.fullName,
                sessionRoleId: User.roleId,
              });
              return;
            }
            window.close();
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetUserChatProfile() {
      this.$call.GetUserChatProfile(
          async (dataResponse) => {
            if (dataResponse.status != 0 || dataResponse.data == null) {
              return;
            }

            const User = dataResponse.data;
            
            localStorage.setItem('token_Snippet', User.token);
            localStorage.setItem('username_Snippet', User.username);
            localStorage.setItem('email_Snippet', User.email);
            localStorage.setItem('isSnippet', true);

            Cookies.set('token_Snippet', User.token);
            Cookies.set('username_Snippet', User.username);
            Cookies.set('email_Snippet', User.email);
            Cookies.set('isSnippet', true);

            sessionStorage.setItem('token_Snippet', User.token);
            sessionStorage.setItem('username_Snippet', User.username);
            sessionStorage.setItem('email_Snippet', User.email);
            sessionStorage.setItem('isSnippet', true);

            const data = this.buildUserChatMessageData();
            const canPostToOpener = window.opener && !window.opener.closed;

            if(canPostToOpener)
            {
              try {
                window.opener.postMessage(data, '*');
                if (this.isLineProvider()) {
                  localStorage.removeItem('lineSSOReturnUrl');
                }
                window.close();
              }
              catch(err) {
                console.error('SSO postMessage failed:', err);
                this.handleStandaloneChatLogin();
              }
            }
            else
            {
              this.handleStandaloneChatLogin();
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
      );
    },
    notifyOpenerAndClose(data) {
      if (window.opener && !window.opener.closed) {
        try {
          // ติด marker ไว้ และส่งเจาะจง origin ของตัวเองแทน '*'
          // หน้า login จะได้แยกออกว่า message ไหนคือ SSO จริง ไม่ reload ตัวเองมั่ว
          // ถ้า opener อยู่คนละ origin message จะไม่ถึง แต่หน้า login มีเส้นเฝ้า popup ปิดรออยู่แล้ว
          window.opener.postMessage({ ...data, type: CONST_SSO_MESSAGE_TYPE }, globalThis.location.origin);
        }
        catch (err) {
          console.error('SSO postMessage failed:', err);
        }
      }

      window.close();
    },
    buildUserChatMessageData() {
      return {
        cookies: document.cookie,
        sessionToken: sessionStorage.getItem('token_Snippet'),
        sessionUsername: sessionStorage.getItem('username_Snippet'),
        sessionEmail: sessionStorage.getItem('email_Snippet'),
        sessionIsSnippet: sessionStorage.getItem('isSnippet'),
      };
    },
    isLineProvider() {
      return String(this.parameterURL.provider || '').toLowerCase() == 'line';
    },
    handleStandaloneChatLogin() {
      if (this.isLineProvider()) {
        this.redirectStandaloneLineLogin();
        return;
      }

      window.close();
    },
    redirectStandaloneLineLogin() {
      const returnUrl = this.getSafeReturnUrl(this.parameterURL.returnurl || localStorage.getItem('lineSSOReturnUrl'));
      localStorage.removeItem('lineSSOReturnUrl');
      if (returnUrl) {
        globalThis.location.replace(this.buildStandaloneLineReturnUrl(returnUrl));
        return;
      }

      this.$router.replace({
        name: 'Snippet',
        query: {
          snippet: 'true',
          domainname: this.parameterURL.domainname,
        },
      });
    },
    getSafeReturnUrl(returnUrl) {
      if (!returnUrl) {
        return null;
      }

      try {
        const parsedUrl = new URL(returnUrl, globalThis.location.origin);
        if (parsedUrl.origin == globalThis.location.origin || this.isAllowedLineEmbedReturnUrl(parsedUrl)) {
          return parsedUrl.href;
        }
      }
      catch (err) {
        console.error('Invalid LINE SSO returnUrl:', err);
      }

      return null;
    },
    isAllowedLineEmbedReturnUrl(parsedUrl) {
      const domainName = String(this.parameterURL.domainname || '').toLowerCase();
      return this.isLineProvider() && domainName && parsedUrl.hostname.toLowerCase() == domainName;
    },
    buildStandaloneLineReturnUrl(returnUrl) {
      const parsedUrl = new URL(returnUrl, globalThis.location.origin);
      if (parsedUrl.origin == globalThis.location.origin) {
        return parsedUrl.href;
      }

      const hash = parsedUrl.hash ? parsedUrl.hash.substring(1) : '';
      const hashParts = hash ? hash.split('&').filter(part => part.indexOf('fusionLineSso=') != 0) : [];
      hashParts.push(`fusionLineSso=${this.buildLineSsoPayload()}`);
      parsedUrl.hash = hashParts.join('&');
      return parsedUrl.href;
    },
    buildLineSsoPayload() {
      const data = this.buildUserChatMessageData();
      const payload = JSON.stringify({
        token: data.sessionToken,
        username: data.sessionUsername,
        email: data.sessionEmail,
        isSnippet: data.sessionIsSnippet || 'true',
      });
      const base64UrlPayload = btoa(encodeURIComponent(payload)).replaceAll('+', '-').replaceAll('/', '_');
      if (base64UrlPayload.endsWith('==')) {
        return base64UrlPayload.slice(0, -2);
      }
      if (base64UrlPayload.endsWith('=')) {
        return base64UrlPayload.slice(0, -1);
      }
      return base64UrlPayload;
    },
  },
};
</script>
